import { useState, useEffect } from 'react';

const navItems = [
  { href: '#hero', label: '首页' },
  { href: '#updates', label: '最新动态' },
  { href: '#media', label: '精彩预告' },
  { href: '#index', label: '专题合集' },
  { href: '#cards', label: '热门推荐' },
  { href: '#comments', label: '观众热评' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between h-[72px] px-4 md:px-6 max-w-[1440px]">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="font-heading text-2xl font-bold text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          90影院
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors rounded-lg hover:bg-background-200/50 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-600 hover:text-primary-500 hover:bg-background-200/50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}